import { HOLIDAY_LABEL_COUNTRY_CODES } from '@/modules/public/search/services/quick-filter-label';

export const FROM_ROOM_TAG_PARAM = 'from_room_tag';

const CHIP_SWITCH_STORAGE_KEY = 'searchEventTypeChipSwitch';

// An event-type chip takes the search to its own event type rather than narrowing the current one by a room tag.
// Ids are RoomTagEntity ids; US and CA land on Holiday Party to match the label their chip shows.
const EVENT_TYPE_CHIPS = [
  { roomTagId: 103, label: 'Christmas Party', slug: 'christmas-party', holidaySlug: 'holiday-party' },
  { roomTagId: 101, label: 'Christmas Dinner', slug: 'christmas-dinner' },
  { roomTagId: 122, label: 'Wedding', slug: 'wedding' },
  { roomTagId: 90, label: 'Birthday Party', slug: 'birthday-party' },
  { roomTagId: 41, label: 'Party', slug: 'party' },
  { roomTagId: 85, label: 'Meeting', slug: 'meeting' },
  { roomTagId: 16, label: 'Conference', slug: 'conference' },
];

const ROOM_TAG_SLUG_PATTERN = /^[a-z0-9-]+$/;

const findEventTypeChip = (quickFilter) => (quickFilter.type === 'room_tags'
  ? EVENT_TYPE_CHIPS.find(({ roomTagId }) => quickFilter.values.map(Number).includes(roomTagId))
  : undefined);

const searchedSlug = (eventTypeChip, ISOCountryCode) => (
  eventTypeChip.holidaySlug && HOLIDAY_LABEL_COUNTRY_CODES.includes(ISOCountryCode)
    ? eventTypeChip.holidaySlug
    : eventTypeChip.slug
);

export const eventTypeChipSlug = (quickFilter, ISOCountryCode) => {
  const eventTypeChip = findEventTypeChip(quickFilter);
  return eventTypeChip ? searchedSlug(eventTypeChip, ISOCountryCode) : null;
};

/**
 * The quick filter of the event-type chip that led the search to this event type. The backend never lists it for
 * the event type itself, so it is rebuilt here to keep the chip shown as selected.
 */
export const eventTypeChipForSlug = (slug, ISOCountryCode) => {
  const eventTypeChip = EVENT_TYPE_CHIPS.find((chip) => searchedSlug(chip, ISOCountryCode) === slug);
  return eventTypeChip
    ? { label: eventTypeChip.label, type: 'room_tags', values: [String(eventTypeChip.roomTagId)] }
    : null;
};

// The slug ends up in the search path, so anything that is not a plain slug is dropped.
export const parseFromRoomTagSlug = (value) => (value && ROOM_TAG_SLUG_PATTERN.test(value) ? value : null);

/**
 * Hands the chips selected before an event-type chip reloaded the search over to the reloaded page – it only knows
 * the chips of its own event type, so theirs would vanish although their filters still apply.
 */
export const saveEventTypeChipSwitch = (searchPath, quickFilters) => {
  try {
    const { pathname } = new URL(searchPath, window.location.href);
    window.sessionStorage.setItem(CHIP_SWITCH_STORAGE_KEY, JSON.stringify({ pathname, quickFilters }));
  } catch {
    // Without sessionStorage the carried chips are lost; their filters still come through the URL.
  }
};

// One-shot, and only for the page it was saved for, so a later search page load never picks up stale chips.
export const takeEventTypeChipSwitch = () => {
  try {
    const chipSwitch = JSON.parse(window.sessionStorage.getItem(CHIP_SWITCH_STORAGE_KEY));
    window.sessionStorage.removeItem(CHIP_SWITCH_STORAGE_KEY);

    return chipSwitch?.pathname === window.location.pathname && Array.isArray(chipSwitch.quickFilters)
      ? { quickFilters: chipSwitch.quickFilters }
      : null;
  } catch {
    return null;
  }
};
